import React, { useEffect, useState, useContext } from "react";
import ThemeContext from "../../contexts/ThemeContext"; 
import "./style.css";

export default function ThemeToggle() {
  const { isDarkMode, setIsDarkMode } = useContext(ThemeContext);


  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
      document.body.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
      document.body.classList.remove('dark');
    }
    window.localStorage.setItem('darkMode', isDarkMode);
  }, [isDarkMode]);


  return (
    <label className="toggle-wrapper" htmlFor="toggle">
      <div className={`toggle ${isDarkMode ? "enabled" : "disabled"}`}>
        <span className="hidden">
          {isDarkMode ? "Enable Light Mode" : "Enable Dark Mode"}
        </span>
        
        <input
          id="toggle"
          name="toggle"
          type="checkbox"
          checked={isDarkMode}
          onChange={() => setIsDarkMode(!isDarkMode)}
        />
      </div>
    </label>
  );
}
